import { fabric } from 'fabric'
import { IEvent } from 'fabric/fabric-impl';
import { nodePalette } from '../../theme';
import PositionObject from '../modules/PositionObject';

export const LinkedGroup = fabric.util.createClass(fabric.Group, {
	type: 'linkedgroup',

	initialize: function (element: any, options: any) {
		this.callSuper('initialize', element, { ...options, hoverCursor: 'pointer' });
		this.set('_components', {})
		this.set('addComponent', (key: string, comp: any) => this._components[key] = comp)
		this.set('getComponent', (key: string) => this._components[key])
		if (options) {

			const linkedObject = options.linkedObject

			if (linkedObject) {
				this.set('linkedObject', options.linkedObject);

				if (linkedObject instanceof PositionObject) {

					this.on('moving', (event: IEvent) => {
						linkedObject.position.x = this.left || 0
						linkedObject.position.y = this.top || 0
					})
				}
			}

		}
	},
})

LinkedGroup.prototype.drawBorders = function (ctx: CanvasRenderingContext2D, styleOverride: any) {

	styleOverride = styleOverride || {};
	const wh = this._calculateCurrentDimensions()
	const width = wh.x
	const height = wh.y
	const radius = (Math.min(width, height) / 2) + 4

	ctx.save();
	ctx.strokeStyle = nodePalette.selection;
	ctx.lineWidth = 4
	this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, undefined);

	ctx.beginPath();
	ctx.ellipse(0, 0, radius, radius, this.angle, 0, 360)
	ctx.closePath();
	ctx.stroke()

	ctx.restore()
	return this;
}
